import http from '@/libs/http'
import moment from 'moment'
import _ from 'lodash'
import Utils from '@/utils'
import { downloadServeFile } from '@/utils/file-download'
/**
 * 加载商户列表
 * @param {*} queryModel
 * @returns
 */
export function loadCustomers (queryModel) {
  return http.post('crm/customer/list', queryModel)
}

/**
 * 获取商户当前服务包
 * @param {商户id} companyId
 * @returns
 */
export function loadCustomerServiceNow (companyId) {
  return http.get('api/sale/client/package/now', { params: { companyId } })
}

export function exportCustomer (queryModel) {
  http({
    url: 'crm/customer/export',
    method: 'POST',
    data: queryModel,
    responseType: 'blob'
  }).then((response) => {
    downloadServeFile(response)
  })
}

/**
 * 获取商户子账号明细
 * @param {商户id} companyId
 * @returns
 */
export function loadCustomerPassport (companyId) {
  return http.get('crm/customer/passport', { params: { id: companyId } })
}

/**
 * 获取商户历史服务包
 * @param {*} companyId
 */
export function loadCustomerServiceHistory (companyId) {
  return http.get('crm/customer/services', { params: { id: companyId } })
}

/**
 * 审批动作
 * @param {*} queryModel
 */
export function DoApprove (queryModel) {
  return http.post('api/business/approve', queryModel)
}

/**
 * 获取配件订单统计
 * @param {*} companyId
 */
export function loadCustomerPartOrder (companyId, startTime, endTime) {
  return http.get('crm/order/buyerstatistic', { params: { id: companyId, startTime: startTime || undefined, endTime: endTime || undefined } }).then((resp) => {
    resp.forEach(item => { item.brandCode = item.brandGrp })
    resp.sort((a, b) => (b.amountPay - b.amountReturn) - (a.amountPay - b.amountReturn))
    return resp
  })
}

export function ListCusumerChange (companyId, startTime, endTime) {
  return http.get('crm/order/BuyerChangeStatistc', { params: { id: companyId, startTime, endTime } }).then((resp) => {
    const periodGrps = _.groupBy(resp, o => o.period)
    const result = []
    for (var period in periodGrps) {
      let bmwData = periodGrps[period].find(t => t.brandGrp === '宝马系') || { amount: 0, amountReturn: 0, orderCount: 0, orderCountReturn: 0 }
      let benzData = periodGrps[period].find(t => t.brandGrp === '奔驰系') || { amount: 0, amountReturn: 0, orderCount: 0, orderCountReturn: 0 }
      let ldData = periodGrps[period].find(t => t.brandGrp === '捷豹路虎') || { amount: 0, amountReturn: 0, orderCount: 0, orderCountReturn: 0 }
      let vwData = periodGrps[period].find(t => t.brandGrp === '大众系') || { amount: 0, amountReturn: 0, orderCount: 0, orderCountReturn: 0 }
      let gmwData = periodGrps[period].find(t => t.brandGrp === '通用系') || { amount: 0, amountReturn: 0, orderCount: 0, orderCountReturn: 0 }
      let otherData = periodGrps[period].find(t => t.brandGrp === '其他') || { amount: 0, amountReturn: 0, orderCount: 0, orderCountReturn: 0 }
      result.push({
        period,
        amountBmw: bmwData.amount,
        orderBmwCount: bmwData.orderCount,
        amountBmwReturn: bmwData.amountReturn,
        orderBmwReturnCount: bmwData.orderCountReturn,
        amountBmwRemain: Utils.DecimalDot2(bmwData.amount - bmwData.amountReturn),
        amountBenz: benzData.amount,
        orderBenzCount: benzData.orderCount,
        amountBenzReturn: benzData.amountReturn,
        orderBenzReturnCount: benzData.orderReturnCount,
        amountBenzRemain: Utils.DecimalDot2(benzData.amount - benzData.amountReturn),
        amountLd: ldData.amount,
        orderLdCount: ldData.orderCount,
        amountLdReturn: ldData.amountReturn,
        orderLdReturnCount: ldData.orderReturnCount,
        amountLdRemain: Utils.DecimalDot2(ldData.amount - ldData.amountReturn),
        amountVw: vwData.amount,
        orderVwCount: vwData.orderCount,
        amountVwReturn: vwData.amountReturn,
        orderVwReturnCount: vwData.orderReturnCount,
        amountVwRemain: Utils.DecimalDot2(vwData.amount - vwData.amountReturn),
        amountGmw: gmwData.amount,
        orderGmwCount: gmwData.orderCount,
        amountGmwReturn: gmwData.amountReturn,
        orderGmwReturnCount: gmwData.orderReturnCount,
        amountGmwRemain: Utils.DecimalDot2(gmwData.amount - gmwData.amountReturn),
        amountOther: otherData.amount,
        orderOtherCount: otherData.orderCount,
        amountOtherReturn: otherData.amountReturn,
        orderOtherReturnCount: otherData.orderReturnCount,
        amountOtherRemain: Utils.DecimalDot2(otherData.amount - otherData.amountReturn)
      })
    }
    result.sort((a, b) => b.period.localeCompare(a.period))
    return result
  })
}

export function searchCompanyByPhone (phone) {
  return http.get('api/sale/client/search', { params: { phone } })
}

export function bind (companyId) {
  return http.post('api/sale/client/bind', { companyId })
}

export function register (queryModel) {
  const { mobile, password, passportName, companyName, province, city, area, addressDetail, taxCode, license, pictures } = queryModel
  const toQuery = {
    phone: mobile,
    code: '',
    password,
    brands: '',
    userName: passportName,
    categoryId: 1,
    business: 1,
    name: companyName,
    identityNo: taxCode || ('0000' + new Date().getTime()),
    province,
    city,
    area,
    address: addressDetail,
    images: pictures && pictures.length ? pictures.map(t => t.url).join(',') : '',
    license: license && license.length ? license[0].url : '',
    customerServices: [{ name: '', mobile: '', qq: '' }]
  }
  return http.post('api/sale/client/register', toQuery)
}

export function ListVinQueryDayChange (type, startTime, endTime, companyId) {
  const url = `api/business/company/daychange/${type}`
  return http.get(url, { params: { startTime, endTime, companyId } }).then((res) => {
    let ret = []
    for (var day = moment(startTime); day.isBefore(moment(endTime)); day = day.add(1, 'day')) {
      var dayData = _.find(res, o => moment(o.date).format('YYYY-MM-DD') === day.format('YYYY-MM-DD'))
      if (dayData) {
        ret.push({
          date: day.format('YYYY-MM-DD'),
          dayCount: dayData.dayCount
        })
      } else {
        ret.push({
          date: day.format('YYYY-MM-DD'),
          dayCount: 0
        })
      }
    }
    return ret
  })
}

export function ListVinQueryDetail (queryModel) {
  return http.get('api/business/company/vinquery/list', { params: queryModel })
}

export function ListCarModelDetail (queryModel) {
  return http.get('api/business/company/modelquery/list', { params: queryModel })
}

export function ListOeDetail (queryModel) {
  return http.get('api/business/company/oequery/list', { params: queryModel })
}

export function ListStockDetail (queryModel) {
  return http.get('api/business/company/stockquery/list', { params: queryModel })
}

export function ListQueryTotal (queryModel) {
  return http.get('api/business/company/total', { params: queryModel })
}

export function QueryAccessLog (companyId) {
  return http.get('crm/customer/querycustaccesslog', { params: { companyId } })
}

export function AppendAccessLog (queryModel) {
  // return new Promise((resolve, reject) => {
  //   setTimeout(() => { resolve(true) }, 1000)
  // })
  return http.post('crm/customer/appendaccesslog', queryModel)
}
